import pino from 'pino';
import pinoHttp from 'pino-http';

const logger = pino({
    prettyPrint: process.env.NODE_ENV === 'development',
    level: process.env.LOG_LEVEL || 'info',
    serializers: {
        err: pino.stdSerializers.err,
        req: pino.stdSerializers.req,
    },
    browser: {
        transmit: {
            level: 'error',
            send: (_level, logEvent) => {
                if (typeof window !== 'undefined' && window.track) {
                    window.track('error', {
                        errorSource: 'client',
                        errorCode: 'unknown',
                        errorMessage: JSON.stringify(logEvent),
                    });
                }
            },
        },
    },
});
const getHttpLogger = (opts) => {
    const { customProps } = opts || {};
    return pinoHttp({
        logger,
        customLogLevel: function (res, err) {
            if (res.statusCode >= 400 && res.statusCode < 500) {
                return 'warn';
            }
            else if (res.statusCode >= 500 || err) {
                return 'error';
            }
            return 'debug';
        },
        autoLogging: true,
        customProps,
    });
};

export { getHttpLogger, logger };
